import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import ModelSelect from "../ui/ModelSelect";

const editableGammeFields = [
    ["date_etude", "Date d’étude", "date", ""],
    ["quantity", "Quantité de pièces", "number", "1"],
    ["labor_price_per_piece", "Prix main-d’œuvre / pièce (MAD)", "number", "0.000001"],
    ["direct_effective", "Effectif standard direct", "number", "0.0001"],
    ["worked_hours", "Heures travaillées", "number", "0.0001"],
    ["allocated_time", "Temps alloué / pièce (min)", "number", "0.000001"],
    ["distribution_key", "Clé de répartition", "number", "0.00000001"],
];

const editablePlanningFields = [
    ["start_date", "Date de début", "date", ""],
    ["end_date", "Date de fin", "date", ""],
    ["main_oeuvre_directe_gamme", "Main d’œuvre directe / Gamme", "number", "0.01"],
    ["main_oeuvre_directe_support", "Main d’œuvre directe / Support", "number", "0.01"],
    ["total_main_oeuvre_directe_affectee", "Total de la main d’œuvre directe affectée", "number", "0.01"],
    ["rendement_prevu_gamme", "Rendement prévu par la gamme", "number", "0.01"],
];

const GammeProd = () => {
    const [chains, setChains] = useState([]);
    const [selectedChain, setSelectedChain] = useState("");
    const [model, setModel] = useState(null);
    const [selectedModel, setSelectedModel] = useState("");
    const [totalChains, setTotalChains] = useState(0);
    const [error, setError] = useState(null);
    const [couteTransport, setCouteTransport] = useState(0);
    const [effectifInDirect, setEffectifInDirect] = useState(0);
    const [systemConstant, setSystemConstant] = useState({
        Nombre_d_heures_par_jour: "",
        Taux_horaire_SMIG_16_29: "",
        Taux_horaire_17_00: "",
        Taux_horaire_17_50: "",
        Masse_salariale_16_29: "",
        Masse_salariale_17_00: "",
        Masse_salariale_17_50: "",
        Capacité_par_unité_transport: "",
        cotisation_entroprise_trans: "",
        Coût_par_trajet: "",
        Coût_énergie_journalier: "",
        Coût_charges_fixes_journalier: "",
    });
    const [totalHours, setTotalHours] = useState(0);
    const [effectifDirect, setEffectifDirect] = useState(0);
    const [models, setModels] = useState([]);
    const [totalMassSalary, setTotalMassSalary] = useState(0);
    const [fils, setFils] = useState(0);
    const [plastique, setPlastique] = useState(0);
    const [coûtEnergie, setCoûtEnergie] = useState(0);
    const [coûtChargesFixes, setCoûtChargesFixes] = useState(0);
    const [coutDeRevient, setCoutDeRevient] = useState(0);
    const [totalExport, setTotalExport] = useState(0);
    const [temp, setTemp] = useState(0);
    const [coutMin, setCoutmin] = useState(0);
    const [totalTemp, setTotalTemp] = useState(0);
    const [rendemen, setRendement] = useState(null);
    const [chainQuantity, setChainQuantity] = useState(0);
    const [cle, setCle] = useState(0);
    const [margeper, setMargeper] = useState(0);
    const [isCost, setIsCost] = useState(0);
    const [selectedPlanId, setSelectedPlanId] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [planStudyExchangeRate, setPlanStudyExchangeRate] = useState(null);
    const [gammeSnapshot, setGammeSnapshot] = useState(null);
    const [savingSnapshot, setSavingSnapshot] = useState(false);
    const [editingSnapshot, setEditingSnapshot] = useState(false);
    const [editData, setEditData] = useState({});
    const [initialEditData, setInitialEditData] = useState({});
    const [editError, setEditError] = useState("");
    const [editSuccess, setEditSuccess] = useState("");
    const [updatingSnapshot, setUpdatingSnapshot] = useState(false);
    const canEditSnapshot = ["admin", "developer"].includes(localStorage.getItem("role"));


    // API call functions
    const getExport = async (selectedModel) => {
        if (selectedModel) {
            try {
                const response = await api.get(`/models/${selectedModel}`);
                if (response.data && response.data.qte_societe) {
                    setTotalExport(response.data.qte_societe);
                }
            } catch (error) {
                console.error("Error fetching export data:", error);
            }
        }
    };

    const getPlanData = async (selectedModel, selectedChain) => {
        if (selectedModel && selectedChain) {
            try {
                const response = await api.get(`/product_plans_model/${selectedModel}/${selectedChain}`);
                setChainQuantity(Number(response.data?.qte) || 0);
                setTotalTemp(Number(response.data?.temps_alloue) || 0);
                setSelectedPlanId(response.data?.id || null);
                setSelectedPlan(response.data || null);
                setPlanStudyExchangeRate(
                    response.data?.cours_devise_etude !== null
                    && response.data?.cours_devise_etude !== undefined
                        ? Number(response.data.cours_devise_etude)
                        : null
                );

                try {
                    const snapshotResponse = await api.get(`/gamme-productions/by-plan/${response.data.id}`);
                    setGammeSnapshot(snapshotResponse.data);
                } catch (snapshotError) {
                    if (snapshotError.response?.status === 404) {
                        setGammeSnapshot(null);
                    } else {
                        throw snapshotError;
                    }
                }
            } catch (error) {
                console.error("Error fetching model/chain plan:", error);
                setChainQuantity(0);
                setTotalTemp(0);
                setSelectedPlanId(null);
                setSelectedPlan(null);
                setPlanStudyExchangeRate(null);
                setGammeSnapshot(null);
            }
        }
    };

    const fetchChainsByModel = async (modelId) => {
        if (!modelId) {
            setChains([]);
            return;
        }

        try {
            const response = await api.get(`/product_plans_chains/${modelId}`);
            setChains(response.data);
        } catch (error) {
            console.error("Error fetching chains by model:", error);
            setChains([]);
        }
    };

    const fetchSystemConstants = async () => {
        try {
            const systemResponse = await api.get("/system_constants_latest");
            if (systemResponse.data) {
                const { id, created_at, updated_at, effectif_fix, ...filteredData } = systemResponse.data;
                setSystemConstant(filteredData);
            }
        } catch (error) {
            console.error("Error fetching system constants:", error);
        }
    };

    const fetchEffectifDirectIndirect = async () => {
        try {
            const responseIndirect = await api.get(`/effective_indirect_total`);
            setEffectifInDirect(parseInt(responseIndirect.data.total_effectif_indirect));
    
            if (selectedModel && selectedChain) {
                const responseDirect = await api.get(`/effective_data_total/${selectedModel}/${selectedChain}`);
                // Get all date keys and sort them to find the latest
                const dateKeys = Object.keys(responseDirect.data || {});
                const latestDate = dateKeys.sort().pop(); // Gets the last (latest) date
                if (!latestDate) {
                    throw new Error("Aucune donnée d’effectif standard trouvée pour ce modèle et cette chaîne.");
                }
                setEffectifDirect(Number(responseDirect.data[latestDate]?.effectifDirects) || 0);
            }
    
            const responseChains = await api.get(`/total_chain`);
            setTotalChains(parseInt(responseChains.data.total_chains));
        } catch (error) {
            console.error("Error fetching direct/indirect effectif data:", error);
            setEffectifDirect(0);
            setError(
                error.response?.data?.message
                || error.message
                || "Impossible de charger les effectifs standard."
            );
        }
    };

    const fetchCle = async (selectedModel, selectedChain) => {
        try {
            const response = await api.get(`/product_plans_cle/${selectedChain}`, {
                params: { model_id: selectedModel, _ts: Date.now() },
                headers: { 'Cache-Control': 'no-cache' },
            });
            setCle(response.data.cle);
        } catch (error) {
            console.error("Error fetching cle:", error);
        }
    };

    const fetchWorkedHours = async (modelId) => {
      try {
        const response = await api.get(`/product_plans_worked_hours_by_chain/${modelId}/${selectedChain}`);
        setTotalHours(response.data.worked_hours_count);
      } catch (error) {
        console.error("Error fetching worked hours:", error);
        setError(error.response?.data?.message || "An error occurred");
      }
    };

    const fetchModels = async () => {
      try {
        const modelsResponse = await api.get("/models");
        setModels(modelsResponse.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };


    
    // Calculation functions
    const calculateCouteTransport = () => {
        const QP_effectif = effectifInDirect * cle;
        const { Nombre_d_heures_par_jour, Capacité_par_unité_transport, Coût_par_trajet, cotisation_entroprise_trans } = systemConstant;
        const Nombre_de_jours_de_production = totalHours / Nombre_d_heures_par_jour;
        const Refacturation_transport_MOD_indirecte = -((cotisation_entroprise_trans * Nombre_de_jours_de_production * QP_effectif) / 26);
        const Refacturation_transport_MOD_directe = -((cotisation_entroprise_trans * Nombre_de_jours_de_production * effectifDirect) / 26);
        const Nombre_unite_utilise = (QP_effectif + effectifDirect) / Capacité_par_unité_transport;
        const transportCost = 2 * Nombre_unite_utilise * Nombre_de_jours_de_production * Coût_par_trajet + (Refacturation_transport_MOD_directe + Refacturation_transport_MOD_indirecte);
    
        setCouteTransport(transportCost);
    };
    
    const calculateTotalMasseSalariale = () => {
        const { Taux_horaire_SMIG_16_29, Taux_horaire_17_00, Taux_horaire_17_50, Masse_salariale_16_29, Masse_salariale_17_00, Masse_salariale_17_50 } = systemConstant;
        const congeAnual = (totalHours * effectifDirect * Taux_horaire_SMIG_16_29 * 1.5) / 26;
        const masseSalariale1629 = totalHours * effectifDirect * Masse_salariale_16_29 * 0.01 * Taux_horaire_SMIG_16_29;
        const masseSalariale1700 = totalHours * effectifDirect * Masse_salariale_17_00 * 0.01 * Taux_horaire_17_00;
        const masseSalariale1750 = totalHours * effectifDirect * Masse_salariale_17_50 * 0.01 * Taux_horaire_17_50;
        const masseSalarialeDirecte = masseSalariale1629 + masseSalariale1700 + masseSalariale1750 + congeAnual;
        
        const QP_effectif = effectifInDirect * cle;
        const congeAnualIndirect = (totalHours * QP_effectif * Taux_horaire_SMIG_16_29 * 1.5) / 26;
        const masseSalarialeIndirect1629 = totalHours * QP_effectif * Masse_salariale_16_29 * 0.01 * Taux_horaire_SMIG_16_29;
        const masseSalarialeIndirect1700 = totalHours * QP_effectif * Masse_salariale_17_00 * 0.01 * Taux_horaire_17_00;
        const masseSalarialeIndirect1750 = totalHours * QP_effectif * Masse_salariale_17_50 * 0.01 * Taux_horaire_17_50;
        const masseSalarialeInDirecte = masseSalarialeIndirect1629 + masseSalarialeIndirect1700 + masseSalarialeIndirect1750 + congeAnualIndirect;
    
        setTotalMassSalary(masseSalarialeInDirecte + masseSalarialeDirecte);
    };
        
    const calculateCouteFilAndPlastique = () => {
        const baseReferenceFil = Number(systemConstant.Base_reference_matiere_fil) || 20000;
        const baseReferencePlastique = Number(systemConstant.Base_reference_matiere_plastique) || 15000;
        const filUnitCost = Number(systemConstant.Coût_fil_unitaire) || 0;
        const plastiqueUnitCost = Number(systemConstant.Coût_plastique_unitaire) || 0;
        const filsValue = chainQuantity * (filUnitCost / baseReferenceFil);
        const plastiqueValue = chainQuantity * (plastiqueUnitCost / baseReferencePlastique);

        setFils(filsValue);
        setPlastique(plastiqueValue);
    };
    
    const calculateCoûtEnergie = () => {
        const { Coût_énergie_journalier, Nombre_d_heures_par_jour } = systemConstant;
        const Nombre_de_jours_de_production = totalHours / Nombre_d_heures_par_jour;
        const energieCost = Nombre_de_jours_de_production * Coût_énergie_journalier * cle;
        
        setCoûtEnergie(energieCost);
    };
  
    const calculateCoûtChargesFixes = () => {
      const { Coût_charges_fixes_journalier, Nombre_d_heures_par_jour } = systemConstant;
      const Nombre_de_jours_de_production = totalHours / Nombre_d_heures_par_jour;
      const chargesFixesCost = Nombre_de_jours_de_production * Coût_charges_fixes_journalier * cle;
      
      setCoûtChargesFixes(chargesFixesCost);
    };

    const calculateCoûtDeRevient = () => {
        const modelData = models.find((model) => {
            return model.id == selectedModel;
          });

        const productionDepotValeur = (
            getLaborPricePerPiece(modelData, planStudyExchangeRate) * chainQuantity
        ).toFixed(2);

        const cout = Number(couteTransport) + Number(coûtEnergie) + Number(coûtChargesFixes) + Number(totalMassSalary)  + Number(fils) + Number(plastique);
    
        const margeBrut = (productionDepotValeur - cout);
        let IS = 0;
        
        if(margeBrut > 0) {
             IS = margeBrut * 0.2;
        } 

        const margeNette = margeBrut - IS;
        const margeper = (margeNette / productionDepotValeur) * 100;
        setMargeper(margeper);
        setIsCost(IS);
        
        setCoutDeRevient(cout + IS);
    };
    
    const calculateCoutmin = () => {
        const cout = Number(coutDeRevient) / temp;
        console.table({
            quantitePieces: Number(chainQuantity),
            tempsAlloueParPiece: Number(totalTemp),
            heuresStandard: Number(totalHours),
            effectifDirect: Number(effectifDirect),
            effectifIndirectTotal: Number(effectifInDirect),
            cleRepartition: Number(cle),
            effectifIndirectAlloue: Number(effectifInDirect) * Number(cle),
            coutTransport: Number(couteTransport),
            masseSalariale: Number(totalMassSalary),
            coutFil: Number(fils),
            coutPlastique: Number(plastique),
            coutEnergie: Number(coûtEnergie),
            chargesFixes: Number(coûtChargesFixes),
            coutTotalAvantIS: Number(coutDeRevient) - Number(isCost),
            IS: Number(isCost),
            coutTotalAvecIS: Number(coutDeRevient),
            minutesProduction: Number(temp),
            coutParMinute: cout,
        });

        setCoutmin(cout);
    };
        
    // helper function
    const handleSelectChange = (e) => {
        setSelectedChain(e.target.value);
        resetMetrics();
        if (!e.target.value) {
            setModel(null);
        }
    };

    const handleModelChange = (e) => {
        setSelectedModel(e.target.value);
        setSelectedChain("");
        setModel(null);
        setChains([]);
        resetMetrics();
    };

    const resetMetrics = () => {
        setError(null);
        setCouteTransport(0);
        setEffectifDirect(0);
        setTotalHours(0);
        setTotalMassSalary(0);
        setFils(0);
        setPlastique(0);
        setCoûtEnergie(0);
        setCoûtChargesFixes(0);
        setCoutDeRevient(0);
        setTemp(0);
        setCoutmin(0);
        setTotalTemp(0);
        setRendement(null);
        setChainQuantity(0);
        setCle(0);
        setMargeper(0);
        setIsCost(0);
        setSelectedPlanId(null);
        setSelectedPlan(null);
        setPlanStudyExchangeRate(null);
        setGammeSnapshot(null);
        setSavingSnapshot(false);
    };

    const getChainName = (chainId) => {
        const chain = chains.find((chain) => chain.id == chainId);
        return chain ? chain.name : "";
    };

    useEffect(() => {
      if (selectedModel && !gammeSnapshot) {
          calculateCouteTransport();
          calculateTotalMasseSalariale();
          calculateCouteFilAndPlastique();
          calculateCoûtEnergie();
          calculateCoûtChargesFixes();
      }
  }, [
      effectifDirect,
      effectifInDirect,
      cle,
      chainQuantity,
      selectedModel,
      systemConstant,
      totalHours,
      gammeSnapshot,
      planStudyExchangeRate,
  ]);

    useEffect(() => {
        const ready = selectedModel && selectedChain && !gammeSnapshot
          && chainQuantity > 0 && totalTemp > 0 && totalHours > 0
          && effectifDirect > 0 && Number.isFinite(Number(cle));

        if (ready) {
          calculateCoûtDeRevient();
        }
    }, [couteTransport, coûtEnergie, coûtChargesFixes, totalMassSalary, fils, plastique, selectedModel, selectedChain, gammeSnapshot, chainQuantity, totalTemp, totalHours, effectifDirect, cle]);
  
    useEffect(() => {
        if (!gammeSnapshot && coutDeRevient > 0 && temp > 0) {
          calculateCoutmin();
        }
      }, [coutDeRevient, temp, isCost, gammeSnapshot]);
      
    useEffect(() => {
        fetchSystemConstants();
    }, []);
    
    useEffect(() => {
      fetchModels();
    }, []);

    useEffect(() => {
      fetchChainsByModel(selectedModel);
    }, [selectedModel]);

    useEffect(() => {
      if (selectedModel && selectedChain) {
          const selectedModelData = models.find(
              (item) => String(item.id) === String(selectedModel)
          );
          setModel(selectedModelData || null);
          getExport(selectedModel);
          getPlanData(selectedModel, selectedChain);
      }
    }, [selectedModel, selectedChain, models]);

    useEffect(() => {
        fetchEffectifDirectIndirect();
    }, [selectedModel, selectedChain]);

    useEffect(() => {
      if (selectedModel && selectedChain) {
        fetchWorkedHours(selectedModel);
      }
    }, [selectedModel, selectedChain]);

    useEffect(() => {
      if (selectedModel && selectedChain) {
        fetchCle(selectedModel, selectedChain);
      }
    }, [selectedModel, selectedChain]);

    useEffect(() => {
      const min_presence = totalHours * effectifDirect * 60;
      const min_produit = chainQuantity * totalTemp; 
      if (min_presence > 0) {
        const Rendement = min_produit / min_presence;
        const tempValue = effectifDirect * totalHours * 60 * Rendement;
        
        setRendement(Rendement);
        setTemp(tempValue);
      }
    }, [effectifDirect, totalHours,chainQuantity, totalTemp]);

    useEffect(() => {
      if (!selectedPlanId || gammeSnapshot || savingSnapshot || !model || !coutMin || !totalTemp) {
        return;
      }

      const laborPricePerPiece = getLaborPricePerPiece(model, planStudyExchangeRate);
      const unitCost = Number(coutMin) * Number(totalTemp);
      const netMarginPerPiece = laborPricePerPiece - unitCost;
      const marginRate = laborPricePerPiece !== 0
        ? (netMarginPerPiece / laborPricePerPiece) * 100
        : 0;

      const saveSnapshot = async () => {
        setSavingSnapshot(true);
        try {
          const response = await api.post('/gamme-productions', {
            product_plan_id: selectedPlanId,
            model_id: Number(selectedModel),
            chain_id: Number(selectedChain),
            quantity: Number(chainQuantity),
            labor_price_per_piece: laborPricePerPiece,
            direct_effective: Number(effectifDirect),
            indirect_effective_allocated: Number(effectifInDirect) * Number(cle),
            worked_hours: Number(totalHours),
            allocated_time: Number(totalTemp),
            distribution_key: Number(cle),
            transport_cost: Number(couteTransport),
            salary_cost: Number(totalMassSalary),
            thread_cost: Number(fils),
            plastic_cost: Number(plastique),
            energy_cost: Number(coûtEnergie),
            fixed_cost: Number(coûtChargesFixes),
            tax_cost: Number(isCost),
            total_cost: Number(coutDeRevient),
            productive_minutes: Number(temp),
            efficiency_rate: Number(rendemen) || 0,
            minute_cost: Number(coutMin),
            unit_cost: unitCost,
            net_margin_per_piece: netMarginPerPiece,
            margin_rate: marginRate,
          });
          setGammeSnapshot(response.data);
        } catch (snapshotError) {
          console.error('Error saving gamme production snapshot:', snapshotError);
        } finally {
          setSavingSnapshot(false);
        }
      };

      saveSnapshot();
    }, [selectedPlanId, gammeSnapshot, savingSnapshot, model, planStudyExchangeRate, coutMin, totalTemp, selectedModel, selectedChain, chainQuantity, effectifDirect, effectifInDirect, cle, totalHours, couteTransport, totalMassSalary, fils, plastique, coûtEnergie, coûtChargesFixes, isCost, coutDeRevient, temp, rendemen, margeper]);

    function formatNumber(value) {
        const numericValue = Number(value);
        if (!Number.isFinite(numericValue)) return "0";

        return new Intl.NumberFormat("fr-FR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(numericValue);
    }

    function getLaborPricePerPiece(modelData, planRate) {
        const laborPrice = Number(modelData?.prixMOver) || 0;
        const modelRate = Number(modelData?.cours_devise_etude);
        const selectedRate = Number(planRate);

        if (planRate !== null && planRate !== undefined && Number.isFinite(selectedRate) && selectedRate > 0) {
            return laborPrice * selectedRate;
        }
        if (modelData?.cours_devise_etude !== null
            && modelData?.cours_devise_etude !== undefined
            && Number.isFinite(modelRate)
            && modelRate > 0) {
            return laborPrice * modelRate;
        }

        return Number(modelData?.qte_societe)
            ? Number(modelData?.prixFacture) / Number(modelData.qte_societe)
            : laborPrice;
    }

    const openEditForm = () => {
        const values = {};
        editableGammeFields.forEach(([name, , type]) => {
            const value = gammeSnapshot?.[name];
            values[name] = type === "number" && value !== null && value !== undefined
                ? String(Number(value))
                : value ?? "";
        });
        editablePlanningFields.forEach(([name, , type]) => {
            const value = selectedPlan?.[name];
            values[name] = type === "number" && value !== null && value !== undefined
                ? String(Number(value))
                : value ?? "";
        });
        setEditData(values);
        setInitialEditData(values);
        setEditError("");
        setEditSuccess("");
        setEditingSnapshot(true);
    };

    const saveEditedSnapshot = async (event) => {
        event.preventDefault();
        setUpdatingSnapshot(true);
        setEditError("");
        setEditSuccess("");
        try {
            const changedFields = (fields) => Object.fromEntries(
                fields
                    .filter(([name, , type]) => type === "number"
                        ? Number(editData[name]) !== Number(initialEditData[name])
                        : editData[name] !== initialEditData[name])
                    .map(([name, , type]) => [
                        name,
                        type === "number" ? Number(editData[name]) : editData[name],
                    ])
            );
            const payload = changedFields(editableGammeFields);
            const planningChanges = changedFields(editablePlanningFields);
            if (Object.keys(planningChanges).length > 0) {
                payload.planning = planningChanges;
            }
            if (Object.keys(payload).length === 0) {
                setEditingSnapshot(false);
                setEditSuccess("Aucune modification à enregistrer.");
                return;
            }
            const response = await api.patch(`/gamme-productions/${gammeSnapshot.id}`, payload, {
                headers: { "Content-Type": "application/json" },
            });
            setGammeSnapshot(response.data);
            setSelectedPlan(response.data.product_plan || selectedPlan);
            setChainQuantity(Number(response.data.quantity) || 0);
            setTotalTemp(Number(response.data.allocated_time) || 0);
            setEffectifDirect(Number(response.data.direct_effective) || 0);
            setCle(Number(response.data.distribution_key) || 0);
            setEditingSnapshot(false);
            setEditSuccess("La gamme de production a été modifiée avec succès.");
        } catch (updateError) {
            const validationErrors = updateError.response?.data?.errors;
            const firstValidationError = validationErrors
                ? Object.values(validationErrors).flat()[0]
                : null;
            setEditError(firstValidationError || updateError.response?.data?.message || "Impossible de modifier la gamme.");
        } finally {
            setUpdatingSnapshot(false);
        }
    };

    const displayedQuantity = gammeSnapshot ? Number(gammeSnapshot.quantity) : Number(chainQuantity);
    const displayedLaborPrice = gammeSnapshot
      ? Number(gammeSnapshot.labor_price_per_piece)
      : getLaborPricePerPiece(model, planStudyExchangeRate);
    const displayedMinuteCost = gammeSnapshot ? Number(gammeSnapshot.minute_cost) : Number(coutMin);
    const displayedUnitCost = gammeSnapshot ? Number(gammeSnapshot.unit_cost) : Number(coutMin) * Number(totalTemp);
    const displayedEfficiency = gammeSnapshot ? Number(gammeSnapshot.efficiency_rate) : Number(rendemen);
    const displayedNetMargin = gammeSnapshot
      ? Number(gammeSnapshot.net_margin_per_piece)
      : displayedLaborPrice - displayedUnitCost;
    // Derive the rate from the same per-piece values displayed above. Older
    // snapshots may contain a stale margin_rate saved during async calculation.
    const displayedMarginRate = displayedLaborPrice !== 0
      ? (displayedNetMargin / displayedLaborPrice) * 100
      : 0;
    

    return (
        <div className="space-y-6">
            {/* Header Section */}
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <div>
                <h2 className="text-2xl font-bold text-gray-900">Indicateurs de la gamme de production</h2>
                <p className="text-gray-600 mt-1">Sélectionnez un modèle, puis une chaîne planifiée pour ce modèle</p>
            </div>
            <div className="flex w-full flex-col gap-4 sm:w-auto sm:flex-row">
              <div className="w-full sm:w-64">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Sélectionner un modèle
                </label>
                <ModelSelect
                    fullWidth
                    value={selectedModel}
                    onChange={handleModelChange}
                    models={models}
                    placeholder="Choisir un modèle..."
                />
              </div>
              <div className="w-full sm:w-64">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Sélectionner une Chaîne de Production
                </label>
            <select
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200 bg-white shadow-sm"
                value={selectedChain}
                onChange={handleSelectChange}
                disabled={!selectedModel}
            >
                    <option value="">
                        {selectedModel ? "Choisir une chaîne..." : "Choisissez d'abord un modèle"}
                    </option>
                {chains.map((chain) => (
                <option key={chain.id} value={chain.id}>
                    {chain.name}
                </option>
                ))}
            </select>
              </div>
            </div>
        </div>

        {error && (
            <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                {error}
            </div>
        )}

            {/* Production Details Card */}
        {model && (
                <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
                    {/* Model Header */}
                    <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4">
                        <div className="flex items-center space-x-4">
                    <img
                        src={`https://api.crosscheckconf.net${model.image}`}
                                alt={model.modele}
                                className="h-16 w-16 rounded-lg object-cover border-2 border-white shadow-md"
                            />
                            <div className="min-w-0 flex-1 text-white">
                                <h3 className="text-xl font-bold">{model.modele}</h3>
                                <p className="text-blue-100">{model.client}</p>
                                <p className="text-blue-200 text-sm">{getChainName(selectedChain)}</p>
                                {gammeSnapshot && <p className="mt-1 text-xs text-blue-100">Gamme enregistrée le {gammeSnapshot.date_etude}</p>}
                            </div>
                            {gammeSnapshot && canEditSnapshot && (
                                <button
                                    type="button"
                                    onClick={openEditForm}
                                    className="rounded-lg bg-white px-4 py-2 text-sm font-semibold text-blue-700 shadow hover:bg-blue-50"
                                >
                                    Modifier
                                </button>
                            )}
                        </div>
                    </div>

                    {editSuccess && (
                        <div className="mx-6 mt-5 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-700">
                            {editSuccess}
                        </div>
                    )}

                    {/* Metrics Grid */}
                    <div className="p-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {/* Basic Info */}
                            <div className="space-y-4">
                                <h4 className="text-lg font-semibold text-gray-900 border-b border-gray-200 pb-2">Informations de Base</h4>
                                
                                <div className="space-y-3">
                                    <div className="flex justify-between items-center py-2 border-b border-gray-100">
                                        <span className="text-sm font-medium text-gray-600">Quantité de Pièces</span>
                                        <span className="text-sm font-bold text-gray-900">{displayedQuantity}</span>
                                    </div>
                                    
                                    <div className="flex justify-between items-center py-2 border-b border-gray-100">
                                        <span className="text-sm font-medium text-gray-600">Prix Main d'Œuvre</span>
                                        <span className="text-sm font-bold text-gray-900">{formatNumber(displayedLaborPrice)} MAD</span>
                                    </div>
                                </div>
                            </div>

                            {/* Cost Metrics */}
                            <div className="space-y-4">
                                <h4 className="text-lg font-semibold text-gray-900 border-b border-gray-200 pb-2">Analyse des Coûts</h4>
                                
                                <div className="space-y-3">
                                    <div className="flex justify-between items-center py-2 border-b border-gray-100">
                                        <span className="text-sm font-medium text-gray-600">Coût par Minute</span>
                                        <span className="text-sm font-bold text-blue-600">{formatNumber(displayedMinuteCost)} MAD</span>
                                    </div>
                                    
                                    <div className="flex justify-between items-center py-2 border-b border-gray-100">
                                        <span className="text-sm font-medium text-gray-600">Coût de revient par pièce</span>
                                        <span className="text-sm font-bold text-gray-900">
                                            {formatNumber(displayedUnitCost)} MAD
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Performance Metrics */}
                            <div className="space-y-4">
                                <h4 className="text-lg font-semibold text-gray-900 border-b border-gray-200 pb-2">Performance</h4>
                                
                                <div className="space-y-3">
                                    <div className="flex justify-between items-center py-2 border-b border-gray-100">
                                        <span className="text-sm font-medium text-gray-600">Taux de Rendement</span>
                                        <span className="text-sm font-bold text-green-600">
                                            {formatNumber(displayedEfficiency * 100)}%
                                        </span>
                                    </div>
                                    
                                    <div className="flex justify-between items-center py-2 border-b border-gray-100">
                                        <span className="text-sm font-medium text-gray-600">Marge Nette par pièce</span>
                                        <span className="text-sm font-bold text-gray-900">
                                            {formatNumber(displayedNetMargin)} MAD
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Margin Rate - Full Width */}
                        <div className="mt-6 pt-6 border-t border-gray-200">
                            <div className="flex justify-between items-center">
                                <span className="text-lg font-semibold text-gray-900">Taux de Marge</span>
                                <div className="text-right">
                                    <span className="text-2xl font-bold text-green-600">
                                        {(() => {
                                            if (!displayedQuantity || !displayedLaborPrice || !displayedMinuteCost) return "⛔ Invalide";
                                            return `${formatNumber(displayedMarginRate)}%`;
                                        })()}
                                    </span>
                                    <p className="text-sm text-gray-600">Pourcentage de marge prévu</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {editingSnapshot && gammeSnapshot && canEditSnapshot && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" role="dialog" aria-modal="true" aria-labelledby="edit-gamme-title">
                    <div className="max-h-[92vh] w-full max-w-5xl overflow-y-auto rounded-xl bg-white shadow-2xl">
                        <div className="sticky top-0 z-10 flex items-center justify-between border-b bg-white px-6 py-4">
                            <div>
                                <h3 id="edit-gamme-title" className="text-xl font-bold text-gray-900">Modifier la gamme de production</h3>
                                <p className="text-sm text-gray-600">{model?.modele} — {getChainName(selectedChain)}</p>
                            </div>
                            <button type="button" onClick={() => setEditingSnapshot(false)} className="rounded p-2 text-2xl text-gray-500 hover:bg-gray-100" aria-label="Fermer">×</button>
                        </div>
                        <form onSubmit={saveEditedSnapshot} className="p-6">
                            <div className="mb-6 grid grid-cols-1 gap-4 rounded-lg bg-gray-50 p-4 text-sm sm:grid-cols-3">
                                <div><span className="font-semibold">Planification :</span> #{gammeSnapshot.product_plan_id}</div>
                                <div><span className="font-semibold">Modèle :</span> {model?.modele}</div>
                                <div><span className="font-semibold">Chaîne :</span> {getChainName(selectedChain)}</div>
                            </div>
                            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                                {editableGammeFields.map(([name, label, type, step]) => (
                                    <label key={name} className="block text-sm font-medium text-gray-700">
                                        {label}
                                        <input
                                            type={type}
                                            step={step || undefined}
                                            value={editData[name] ?? ""}
                                            onChange={(event) => setEditData((previous) => ({ ...previous, [name]: event.target.value }))}
                                            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                                            required
                                        />
                                    </label>
                                ))}
                            </div>
                            <h4 className="mb-4 mt-7 border-b pb-2 text-lg font-semibold text-gray-900">Données de la planification</h4>
                            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                                {editablePlanningFields.map(([name, label, type, step]) => (
                                    <label key={name} className="block text-sm font-medium text-gray-700">
                                        {label}
                                        <input
                                            type={type}
                                            step={step || undefined}
                                            value={editData[name] ?? ""}
                                            onChange={(event) => setEditData((previous) => ({ ...previous, [name]: event.target.value }))}
                                            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                                            required
                                        />
                                    </label>
                                ))}
                            </div>
                            {editError && <div className="mt-5 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{editError}</div>}
                            <div className="mt-6 flex justify-end gap-3 border-t pt-5">
                                <button type="button" onClick={() => setEditingSnapshot(false)} disabled={updatingSnapshot} className="rounded-lg border border-gray-300 px-5 py-2.5 font-semibold text-gray-700 hover:bg-gray-50">Annuler</button>
                                <button type="submit" disabled={updatingSnapshot} className="rounded-lg bg-blue-600 px-5 py-2.5 font-semibold text-white hover:bg-blue-700 disabled:opacity-60">
                                    {updatingSnapshot ? "Enregistrement…" : "Enregistrer les modifications"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* No Selection State */}
            {!model && (
                <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-12 text-center">
                    <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                        </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Aucun modèle et chaîne sélectionnés</h3>
                    <p className="text-gray-600">Veuillez sélectionner un modèle, puis l'une de ses chaînes planifiées pour voir les métriques et analyses détaillées.</p>
                </div>
            )}
        </div>
    );
};

export default GammeProd;
